import { render, staticRenderFns } from "./labHome.vue?vue&type=template&id=360212be&scoped=true&"
import script from "./labHome.vue?vue&type=script&lang=js&"
export * from "./labHome.vue?vue&type=script&lang=js&"
import style0 from "./labHome.vue?vue&type=style&index=0&id=360212be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360212be",
  null
  
)

export default component.exports